import { Component, input } from '@angular/core';
import { IonSpinner } from "@ionic/angular/standalone";

@Component({
  selector: 'lib-spinner',
  imports: [IonSpinner, ],
  templateUrl: './spinner.component.html',
  styles: [`
    ion-spinner {
      --color: currentColor; // Variable reservada d'Ionic per agafar el valor de la propietat "color"
    }
  `]
})
export class SpinnerComponent {
  name = input<string>('crescent');
}